import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { QRCodeModule } from 'angularx-qrcode';
import { SharedModule } from 'src/app/shared/shared.module';
import { AccountInformationComponent } from './edit-account/components/account-information/account-information.component';
import { GenerateQrCodeComponent } from './edit-account/components/generate-qr-code/generate-qr-code.component';
import { MigrateToWaCloudApiComponent } from './edit-account/components/migrate-to-wa-cloud-api/migrate-to-wa-cloud-api.component';
import { InMessageEmailCustomizationComponent } from './edit-account/components/in-message-email-customization/in-message-email-customization.component';
import { KakaotalkEngagementInformationComponent } from './edit-account/components/kakaotalk-engagement-information/kakaotalk-engagement-information.component';

@NgModule({
  declarations: [
    AccountInformationComponent,
    GenerateQrCodeComponent,
    MigrateToWaCloudApiComponent,
    InMessageEmailCustomizationComponent,
    KakaotalkEngagementInformationComponent,
  ],
  imports: [CommonModule, SharedModule, QRCodeModule],
})
export class AccountsModule {}
